import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { FiCheck, FiX } from 'react-icons/fi';

const LedOnButton = ({
   label,
   value,
   x,
   y,
   width,
   height,
   disabled,
   ghost,
   highlighted,
   onClick,
}) => {
   return (
      <g
         className={classNames('led-on-button', {
            disabled,
            ghost,
            highlighted,
            on: value,
         })}
         onClick={onClick}
      >
         {highlighted && (
            <rect
               className="button-highlight"
               x={x - 4}
               y={y - 4}
               width={width + 8}
               height={height + 8}
               rx={8}
               ry={8}
            />
         )}
         <rect
            className="button-body"
            x={x}
            y={y}
            width={width}
            height={height}
            rx={4}
            ry={4}
         />
         <rect
            className="button-on-indicator"
            x={x + (width - width / 2) / 2}
            y={y + height - (height > 25 ? 6 : 4)}
            width={width / 2}
            height={2}
            rx={1}
            ry={1}
         />
         <text
            className="button-label"
            x={x + width / 2}
            y={y + height / 2 + 1}
            textAnchor="middle"
            dominantBaseline="middle"
         >
            {label}
         </text>
      </g>
   );
};

export { LedOnButton };
